import { Box } from '@mui/material';
import { DebouncedTextField } from './DebouncedTextField';
import { JourneyHistory } from './types';

interface Props {
  data: JourneyHistory;
  onChange: (data: JourneyHistory) => void;
  disabled?: boolean;
}

/**
 * Renders the editable Journey History summary text.
 * @param props - journey history data, change handler, and disabled flag
 * @example `<CopilotJourneyHistorySection data={...} onChange={...} />`
 */
export function CopilotJourneyHistorySection({ data, onChange, disabled = false }: Props) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, opacity: disabled ? 0.5 : 1, pointerEvents: disabled ? 'none' : 'auto' }}>
      <DebouncedTextField
        label="Journey Summary Text"
        multiline
        minRows={2}
        fullWidth
        size="small"
        disabled={disabled}
        value={data.journeySummaryText}
        onChange={(v) => onChange({ ...data, journeySummaryText: v })}
      />
    </Box>
  );
}

export default CopilotJourneyHistorySection;
